import React from 'react'
import PropTypes from 'prop-types'

import calculateContentOffset from '../../utils/calculateContentOffset'

import Box from '../Box'
import Heading from '../Heading'
import SelectBox from '../SelectBox'
import TabBar from '../TabBar'

const PageHeader = (props) => {
  const {
    actionContent,
    activeTabBarItemKey,
    boxProps,
    heading,
    lowerRightContent,
    nestedNavigation,
    offset,
    offset: {
      top,
    },
    tabBarItems,
    title,
    width,
  } = props

  const leftOffset = calculateContentOffset(offset, { nestedNavigation })

  return (
    <Box
      backgroundColor="white"
      borderBottom="1px solid"
      borderColor="lineColor"
      flexDirection="column"
      paddingTop="large"
      paddingBottom={tabBarItems ? 0 : 'large'}
      position="fixed"
      px="large"
      style={{
        top: typeof top !== 'undefined' ? top : 55,
        right: 0,
        zIndex: 10,
        left: leftOffset,
        width: width || `calc(100% - ${leftOffset || 0}px)`,
      }}
      {...boxProps}
    >
      <Box alignItems="center" flexShrink="0" height={37}>
        {heading || <Heading>{title || 'Header'}</Heading>}

        <Box alignItems="center" marginLeft="auto" justifyContent="flexEnd" width="auto">
          {actionContent}
        </Box>
      </Box>

      <Box flexShrink="0" style={{ position: 'absolute', bottom: 0, width: 'calc(100% - 32px)' }}>
        {tabBarItems && (
          <Box marginTop={16} marginBottom={0}>
            <Box display={['inline-flex', 'none']} paddingBottom="large">
              <SelectBox
                selectedItemKey={activeTabBarItemKey}
                items={tabBarItems}
                size="medium"
              />
            </Box>

            <Box display={['none', 'inline-flex']}>
              <TabBar
                selectedItemKey={activeTabBarItemKey}
                items={tabBarItems}
              />
            </Box>
          </Box>
        )}

        <Box alignItems="center" justifyContent="flex-end">
          {lowerRightContent}
        </Box>
      </Box>
    </Box>
  )
}

PageHeader.propTypes = {
  actionContent: PropTypes.node,
  activeTabBarItemKey: PropTypes.string,
  boxProps: PropTypes.object,
  callbacks: PropTypes.object,
  heading: PropTypes.node,
  lowerRightContent: PropTypes.node,
  nestedNavigation: PropTypes.bool,
  offset: PropTypes.object,
  tabBarItems: PropTypes.array,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

PageHeader.defaultProps = {
  offset: {},
}

export default PageHeader
